// All the tabs
const tabs = [
  { label: 'Entry Label', title: 'Entry Header Information' },
  { label: 'Importer', title: 'Importer Information' },
  { label: 'Consignee', title: 'Consignee Information' },
  { label: 'Transportation', title: 'Transportation & Arrival Information' },
  { label: 'Invoice', title: 'Invoice & Financial Information' },
  { label: 'Line Items', title: 'Entry Line Items' },
  { label: 'Summary', title: 'Summary & Declaration' },
];

// All the drop down options
const entryTypes = [
  { value: '01', label: '01 - Consumption - Free & Dutiable' },
  { value: '02', label: '02 - Consumption - Quota/Visa' },
  { value: '03', label: '03 - Consumption - AD/CVD' },
  { value: '06', label: '06 - Foreign Trade Zone (FTZ)' },
  { value: '07', label: '07 - Consumption - Quota/Visa & AD/CVD' },
  { value: '11', label: '11 - Informal - Free & Dutiable' },
  { value: '12', label: '12 - Informal - Quota/Visa' },
  { value: '13', label: '13 - Informal - Mail' },
  { value: '21', label: '21 - Warehouse' },
  { value: '22', label: '22 - Re-warehouse' },
  { value: '23', label: '23 - Temporary Importation under Bond (TIB)' },
  { value: '31', label: '31 - Warehouse Withdrawal - Consumption' },
  { value: '32', label: '32 - Warehouse Withdrawal - Quota' },
  { value: '34', label: '34 - Warehouse Withdrawal - AD/CVD' },
  { value: '38', label: '38 - Warehouse Withdrawal - Quota & AD/CVD' },
  { value: '51', label: '51 - Military - Defense Contract Management Agency (DCMA)' },
  { value: '52', label: '52 - Government - Dutiable' },
];

const bondTypes = [
  { value: '8', label: '8 - Continuous' },
  { value: '9', label: '9 - Single Transaction' },
];

const modesOfTransportation = [
  { value: '10', label: '10 - Vessel, Non-Containerized' },
  { value: '11', label: '11 - Vessel, Containerized' },
  { value: '12', label: '12 - Border Water Borne' },
  { value: '20', label: '20 - Rail, Non-Containerized' },
  { value: '21', label: '21 - Rail, Containerized' },
  { value: '30', label: '30 - Truck, Non-Containerized' },
  { value: '31', label: '31 - Truck, Containerized' },
  { value: '32', label: '32 - Auto' },
  { value: '33', label: '33 - Pedestrian' },
  { value: '34', label: '34 - Road, Other' },
  { value: '40', label: '40 - Air, Non-Containerized' },
  { value: '41', label: '41 - Air, Containerized' },
  { value: '50', label: '50 - Mail' },
  { value: '60', label: '60 - Passenger, Hand Carried' },
  { value: '70', label: '70 - Fixed Transport' },
];

const termsOfSaleOptions = [
  { value: 'CIF', label: 'CIF - Cost, Insurance, Freight' },
  { value: 'C&F', label: 'C&F - Cost and Freight' },
  { value: 'FOB', label: 'FOB - Free on Board' },
  { value: 'FAS', label: 'FAS - Free Alongside Ship' },
  { value: 'EXW', label: 'EXW - Ex Works' },
];

const unitOfMeasures = [
  { value: 'NO', label: 'NO - Number' },
  { value: 'DZ', label: 'DZ - Dozen' },
  { value: 'GR', label: 'GR - Gross' },
  { value: 'KG', label: 'KG - Kilogram' },
  { value: 'LB', label: 'LB - Pound' },
  { value: 'L', label: 'L - Liter' },
  { value: 'M', label: 'M - Meter' },
  { value: 'M2', label: 'M2 - Square Meter' },
  { value: 'M3', label: 'M3 - Cubic Meter' },
  { value: 'PR', label: 'PR - Pair' },
  { value: 'DOZ', label: 'DOZ - Dozen Pair' },
  { value: 'PCS', label: 'PCS - Pieces' },
  { value: 'CTN', label: 'CTN - Carton' },
];

const weightUnits = [
  { value: 'K', label: 'K - Kilograms' },
  { value: 'L', label: 'L - Pounds' },
];

const relatedPartyOptions = [
  { value: 'N', label: 'N - No' },
  { value: 'Y', label: 'Y - Yes' },
];

// Intended Use Codes that require an Intended Use Description (per CBP rules)
export const INTENDED_USE_CODES_REQUIRING_DESCRIPTION = ['980.000'];